import { onlyRoleMapping, userHasLevel } from "../../../engine/AuthRoute";
import {
  languagesList,
  levels,
  modeInterpretariat,
  renderUserNameEmail,
  roles,
  statusPrestations,
  statusPrestationsActual,
  statusPrestationsValues,
  subRoles,
  typeIntervention,
} from "../../../utils/constants";
import { AiFillCalendar } from "react-icons/ai";
import React, { useContext, useEffect, useState } from "react";
import dayjs from "../../../utils/dayjs";
import { BiLinkExternal } from "react-icons/bi";
import { typesPrestation } from "../../../utils/typesPrestation";
import { Alert, Button, Space } from "antd";
import { IoAddSharp } from "react-icons/io5";
import { CreateApplicant } from "../../../shared/components/CreateApplicant/CreateApplicant";
import { modalsByContext } from "../../../shared/components/Modals/modals";
import { typeAddress } from "../../../shared/container/Addresses/AddresseItem/AddresseHelpers";
import { ModalContext } from "../../../engine/context/Modal.provider";
import { LuMapPin } from "react-icons/lu";
import { usePrestationDisabler } from "../../../engine/hooks/usePrestationDisabler";
import { isArray } from "lodash";

import { useTranslation } from "react-i18next";
import { t } from "i18next";
import { UserContext } from "../../../engine/context/User.context";
import {
  disabledDateNext12Months,
  disabledDatePast,
  validateTimeBetween,
} from "../../../shared/components/CustomForm/form.helpers";
import { DurationHourChecker } from "./DurationHourChecker";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

const BookingRestrictionAlert = () => {
  const { bookingRestrictionError } = useSelector(state => state.prestation);
  if (!bookingRestrictionError) return null;
  const message =
    typeof bookingRestrictionError === "object" && bookingRestrictionError?.code
      ? t(`prestations.bookingRestriction.${bookingRestrictionError.code}`, {
          from: bookingRestrictionError.from,
          to: bookingRestrictionError.to,
        })
      : bookingRestrictionError;
  return (
    <Alert
      style={{ width: "100%" }}
      message={message}
      type="error"
      showIcon
    />
  );
};

export const prestationInputs = (
  prestation,
  formRef,
  change,
  setChange,
  user,
  dataForm,
  setDataForm,
) => {
  const { configuration } = useContext(UserContext);

  const locationRouteur = useLocation();

  const [listCategories, setListCategories] = useState(typesPrestation());

  useEffect(() => {
    if (dataForm.institution) {
      let institution = dataForm.institution;

      if (typeof dataForm.institution === "string") {
        institution = formRef.current?._institution?.find(
          e => e._id === dataForm.institution,
        );
      }

      let filtered = typesPrestation().filter(item => {
        if (institution?.mainType && institution?.mainType !== "") {
          return institution?.mainType === item.value;
        } else {
          return true;
        }

        // if (
        //     formRef.current === null ||
        //     formRef.current?._institution === undefined ||
        //     formRef.current?._institution?.length === 0
        // ) {
        //   return false;
        // } else {
        //   let institutionId = formRef.current.getFieldValue("institution");
        //   let institution = formRef.current._institution.find(
        //       e => e._id === institutionId,
        //   );
        //
        // }
      });

      if (filtered.length === 0) {
        filtered = typesPrestation();
      }

      setListCategories(filtered);
    }
  }, [dataForm.institution]);

  const {
    intervention: { startDate, endDate, location, extra },
    comment,
    applicationAt = null,
    category,
    institution,
    applicant,
    isSequentialPrestation,
  } = prestation;

  const context = useContext(ModalContext);

  let isDraft = prestation.status === statusPrestationsValues.draft;

  const setAdressByList = () => {
    let selected = formRef.current.getFieldValue("intervention.locationTo");

    const addresses = formRef.current["_intervention.locationTo"];

    let findAddress = addresses.find(e => e._id === selected);

    formRef.current.setFieldsValue({
      "intervention.location": findAddress.maps,
      "intervention.locationName": findAddress.location,
    });
  };

  const disabledPast = current => {
    // Rule 1: Not in past
    return current && current < dayjs().startOf("day");
  };

  const disabledDates = current => {
    if (onlyRoleMapping([roles.institution])) {
      return disabledDatePast(current) || disabledDateNext12Months(current);
    } else {
      return false;
    }
  };

  return [
    {
      parentLabel: "",
      children: [
        {
          label: t("prestationInputs.orderNumber"),
          placeholder: t("prestationInputs.generatedAutomatically"),
          name: "reference",
          disabled: true,
          capitalize: false,
          type: "input",
          variant: "important",
          col: 24,
        },
        {
          label: t("prestationInputs.applicantInstitution"),
          disabled: !isDraft,
          name: "institution",
          // value: userHasLevel({
          //   not: {
          //     [roles.institution]: "", //
          //   },
          // })
          //   ? institution?._id
          //   : user.institution,
          value: institution?._id,
          type: "dynamic-select",
          required: true,
          endPoint: "institutions?format=short",
          onChange: ({ dynamicSource }) => {
            if (dynamicSource?.category !== undefined) {
              formRef.current.setFieldsValue({
                category: [dynamicSource.category],
              });
            }
          },
          itemsCallBack: (institutions, form) => {
            if (
              locationRouteur?.state !== null &&
              prestation._id === undefined
            ) {
              let findInstitution = institutions.find(
                e => e._id === locationRouteur.state.institution,
              );
              if (findInstitution?.category !== undefined) {
                form.setFieldsValue({
                  category: [findInstitution.category],
                });
              }
            }
          },
          itemCallback: item => {
            return {
              key: item._id,
              label: `${item.name}`,
              value: item._id,
            };
          },
          col: 24,
        },
        {
          label: t("prestationInputs.category"),
          name: "category",
          showSearch: true,
          // hidden: dataForm.institution === undefined,
          value: category,
          defaultValue: category,
          // watchRenderCondition: true,
          multiple: true,
          type: "select",
          // selectContent: [],
          selectContent: listCategories,
          selectType: "group",
          col: 24,
          // watchDynamicObject: "institution",
          // filterContent: (item, institution) => {
          //   if (institution?.mainType && institution?.mainType !== "") {
          //     return true;
          //   } else {
          //     return true;
          //   }
          // },
        },
        {
          label: t("prestationInputs.status"),
          name: "status",
          disabled: true,
          type: "select",
          selectContent: statusPrestationsActual,
          col: 24,
        },
        {
          required: true,
          showSearch: true,
          disabled: !isDraft,
          label: t("prestationInputs.serviceLanguage"),
          quote: (
            <>
              <b>Arabo Maghreb:</b> generalmente parlato in Tunisia, Marocco,
              Algeria, Libia, Sahara occidentale, Mauritania.
              <br />
              <b>Arabo Levante:</b> generalmente parlato in alcuni paesi del
              Medio Oriente come Siria, Iraq, Libano, Giordania, Palestina.
              <br /> <b>Arabo Classico/letterario:</b> generalmente parlato in
              Egitto, Sudan, Ciad, Arabia Saudita
            </>
          ),
          quoteStyle: "large",
          name: "languages",
          value: prestation.languages,
          type: "dynamic-select",
          endPoint: "users/languages",
          col: 24,
          // onChange: value => {
          //   setLanguageSearch(value);
          // },
          itemCallback: item => {
            let trad = languagesList().find(e => e.value === item.value);
            return {
              key: item.value,
              label: `${trad ? trad.label : item.value}`,
              value: item.value,
            };
          },
        },
        {
          label: t("prestationInputs.requestSubmissionDate"),
          quote: t("prestationInputs.automaticOnOrderConfirmation"),
          name: "applicationAt",
          visible: userHasLevel({
            only: {
              [roles.permanance]: "crud", //
              [roles.admin]: "crud", //
            },
          }),
          value: applicationAt === null ? undefined : dayjs(applicationAt),
          suffixIcon: <AiFillCalendar />,
          showTime: true,
          showClear: true,
          type: "date-time",
          col: 24,
        },
        {
          required: true,
          label: t("prestationInputs.startDateTime"),
          name: "intervention.startDate",
          rules: [
            refValidator => ({
              validator(_) {
                return validateTimeBetween(
                  refValidator,
                  "intervention.startDate",
                  "intervention.endDate",
                  user,
                  prestation.isLongDuration,
                );
              },
            }),
          ],
          value: dayjs(startDate),
          suffixIcon: <AiFillCalendar />,
          onChange: props => {
            let val;

            if (props.format !== undefined) {
              val = props.format();
            }

            if (props.value !== undefined) {
              val = props.value.format();
            }

            setDataForm({
              ...dataForm,
              "intervention.startDate": val,
            });
          },
          showTime: true,
          watch: "intervention.endDate",
          watchRenderCondition: false,
          disabledDate: disabledDates,
          watchValuesCallback: (start, end, ref) => {
            try {
              if (!end || !start) return;

              // Check the difference in minutes
              const differenceInMinutes = end.diff(start, "minute");

              // If start is after or exactly at the same time as end
              if (differenceInMinutes <= 0) {
                // let newStartD = end.subtract(1, "hour");
                // ref.current.setFieldsValue({
                //   "intervention.startDate": newStartD,
                // });
                // setDataForm({
                //   ...dataForm,
                //   "intervention.startDate": newStartD.format(),
                // });
              }
            } catch (e) {
              console.log(e);
            }
          },
          type: "date-time",
          col: 12,
        },
        {
          required: true,
          label: t("prestationInputs.endDateTime"),
          rules: [
            refValidator => ({
              validator(_) {
                return validateTimeBetween(
                  refValidator,
                  "intervention.startDate",
                  "intervention.endDate",
                  user,
                  prestation.isLongDuration,
                );
              },
            }),
          ],
          name: "intervention.endDate",
          value: dayjs(endDate),
          suffixIcon: <AiFillCalendar />,
          onChange: props => {
            let val;

            if (props.format !== undefined) {
              val = props.format();
            }

            if (props.value !== undefined) {
              val = props.value.format();
            }
            setDataForm({
              ...dataForm,
              "intervention.endDate": val,
            });
          },
          watch: "intervention.startDate",
          disabledDate: disabledDates,
          watchRenderCondition: false,
          watchValuesCallback: (end, start, ref) => {
            try {
              if (!end || !start) return;

              // Check the difference in minutes
              const differenceInMinutes = start.diff(end, "minute");

              // If end is before or exactly at the same time as start
              if (differenceInMinutes >= 0) {
                let newEndD = start.add(1, "hour");
                ref.current.setFieldsValue({
                  "intervention.endDate": newEndD,
                });
                setDataForm({
                  ...dataForm,
                  "intervention.endDate": newEndD.format(),
                });
              }
            } catch (e) {
              console.log(e);
            }
          },
          showTime: true,
          type: "date-time",
          col: 12,
        },
        {
          col: 24,
          type: "component",
          name: "durationHour",
          noWrapper: true,
          component: ({ refForm }) => (
            <DurationHourChecker
              keys={["intervention.startDate", "intervention.endDate"]}
              isLongDuration={prestation.isLongDuration}
            />
          ),
        },
        {
          col: 24,
          type: "component",
          name: "bookingRestrictionAlert",
          noWrapper: true,
          component: () => <BookingRestrictionAlert />,
        },
      ],
    },
    typeInterventionInputs({
      type: dataForm?.intervention?.type,
      linkVisio: dataForm?.intervention?.linkVisio,
    }),
    {
      parentLabel: t("prestationInputs.interventionLocationInstitution"),
      children: [
        {
          type: "component",
          watchDynamicObject: "institution",
          watchRenderCondition: true,
          component: ({ disabled }) => {
            return (
              <Space direction={"horizontal"}>
                <Button
                  disabled={disabled}
                  type={"primary"}
                  onClick={() => {
                    let instituionId = formRef.current.getFieldValue(
                      "institution",
                    );
                    context.openModal(
                      modalsByContext.InstitutionSelectAddress,
                      {
                        institution: instituionId,
                        formRef,
                      },
                      ({ _id, data }) => {
                        if (data) {
                          formRef.current.setFieldsValue({
                            "intervention.location": data.maps,
                            "intervention.locationName": data.location,
                          });
                          setChange(_id);
                        }
                      },
                    );
                  }}
                  icon={
                    <LuMapPin
                      style={{
                        marginTop: "0px",
                      }}
                      size={15}
                    />
                  }
                  size={"small"}
                >
                  {t("prestationInputs.selectPredefinedLocation")}
                </Button>
                <Button
                  disabled={disabled}
                  type={"primary"}
                  onClick={() => {
                    let instituionId = formRef.current.getFieldValue(
                      "institution",
                    );
                    context.openModal(
                      modalsByContext.InstitutionNewAddress,
                      {
                        institution: instituionId,
                        principal: null,
                        type: typeAddress.maps,
                      },
                      ({ _id, data }) => {
                        if (data) {
                          formRef.current.setFieldsValue({
                            "intervention.location": data.maps,
                            "intervention.locationName": data.location,
                          });
                          setChange(_id);
                        }
                      },
                    );
                  }}
                  size={"small"}
                  style={{
                    justifySelf: "flex-start",
                    display: "flex",
                  }}
                  icon={
                    <IoAddSharp
                      style={{
                        marginTop: "0px",
                      }}
                      size={25}
                    />
                  }
                >
                  {t("prestationInputs.addInterventionLocation")}
                </Button>
              </Space>
            );
          },
          col: 24,
        },
        {
          label: t("prestationInputs.interventionLocationInstitution"),
          name: "intervention.locationName",
          disabled: true,
          type: "input",
          watchRequiredCondition: true,
          watch: "intervention.type",
          watchValues: [typeIntervention.in_person],
          col: 24,
        },
        {
          label: t("prestationInputs.interventionAddress"),
          disabled: true,
          name: "intervention.location",
          watch: "intervention.type",
          watchValues: [typeIntervention.in_person],
          watchRequiredCondition: true,
          watchValuesCallback: (value, form, r) => {},
          value: prestation.intervention.location,
          type: "google-adress",
          col: 24,
          // watchDynamicObject: "institution",
          // watchDynamicSetEmpty: true,
          // watchRenderCondition: true,
          // watchDynamicSetter: institution => institution?.interventionLocation,
        },
        {
          visible:
            userHasLevel({
              only: {
                [roles.admin]: "crud", //
              },
            }) && [statusPrestationsValues.planned].includes(prestation.status),
          label: t("prestationInputs.interpreterDepartureLocation"),
          name: "intervention.locationFrom",
          value: prestation.intervention.locationFrom,
          type: "google-adress",
          col: 24,
        },
        {
          label: t("prestationInputs.interventionLocationExtra"),
          name: "intervention.extra",
          type: "input",
          watch: "intervention.type",
          watchValues: [
            typeIntervention.visio,
            typeIntervention.in_person,
            typeIntervention.phone,
          ],
          col: 24,
        },
        {
          label: t("prestationInputs.followedInterventionLabel"),
          description: (
            <span>{t("prestationInputs.followedInterventionDescription")}</span>
          ),
          name: "isSequentialPrestation",
          visible: userHasLevel({
            only: {
              [roles.admin]: "r", //
              [roles.permanance]: "r", //
            },
          }),
          type: "checkbox-bool",
          value: isSequentialPrestation,
          col: 24,
        },
      ],
    },
    {
      parentLabel: t("prestationInputs.interpreterCriteria"),
      children: [
        {
          required: true,
          label: t("prestationInputs.interpreterGender"),
          name: "search.searchGenre",
          type: "select",
          multiple: true,
          selectContent: [
            { label: t("prestationInputs.female"), value: "female" },
            { label: t("prestationInputs.male"), value: "male" },
          ],
          col: 24,
        },
        {
          required: true,
          label: t("prestationInputs.interpreterLevel"),
          visible: configuration?.prestation?.institutionCanSeeCritereaSearch
            ? true
            : onlyRoleMapping([roles.admin, roles.permanance]),
          name: "search.searchLevel",
          type: "select",
          multiple: true,
          selectContent: levels(),
          col: 24,
        },
      ],
    },
    {
      parentLabel: t("prestationInputs.applicantInformation"),
      children: [
        {
          label: t("prestationInputs.applicant"),
          name: "applicant",
          required: true,
          value: applicant?._id,
          type: "dynamic-select",
          endPoint: institution =>
            `/users?subRole=${subRoles.institutionDemander}&institutions=${institution}&status=active,inactive`,
          watchDynamicObject: "institution",
          watchRenderCondition: true,
          watchDynamicSetEmpty: true,
          updateEndPoint: [change],
          itemsCallBack: (users, form) => {},
          filterItem: item => {
            if (
              user.subRoles.includes(subRoles.institutionDemander) &&
              !user.subRoles.includes(subRoles.institutionAdmin)
            ) {
              return item._id === user._id;
            } else {
              return true;
            }
          },
          itemCallback: item => {
            return {
              key: item._id,
              label: renderUserNameEmail(item),
              value: item._id,
            };
          },
          col: 24,
        },
        {
          type: "component",
          watchDynamicObject: "institution",
          watchRenderCondition: true,
          component: ({ disabled }) => {
            return (
              <>
                {onlyRoleMapping([roles.admin, roles.permanance, subRoles.institutionAdmin]) ? (
                  <CreateApplicant
                    disabled={disabled}
                    key={Math.random()}
                    name={"applicant"}
                    formRef={formRef}
                    onCreated={_id => {
                      setChange(_id);
                    }}
                  />) : null}
              </>
            );
          },
          col: 24,
        },
      ],
    },
    {
      children: [
        {
          label: t("prestationInputs.saveAndNext"),
          name: "send",
          value: "send",
          type: "submit",
          col: 24,
          align: "right",
        },
      ],
    },
  ];
};

export const typeInterventionInputs = props => {
  const { configuration } = useContext(UserContext);

  const { prestation } = useSelector(state => state.prestation);

  let interpreteRef = props?.interpreteRef || null;
  let hidden = props?.hidden || false;

  let interpretingMode = interpreteRef?.interpreteData?.interpretingMode;

  let modeInterpretariatFinal = modeInterpretariat();

  if (isArray(interpretingMode)) {
    modeInterpretariatFinal = modeInterpretariat().map(p => {
      if (interpretingMode.includes(p.value)) {
        return p;
      } else {
        return { ...p, disabled: true };
      }
    });
  }

  return {
    parentLabel: null,
    children: [
      {
        label: t("prestationInputs.interventionType"),
        name: "intervention.type",
        required: true,
        value: prestation?.intervention?.type || null,
        type: "radios",
        radios: modeInterpretariatFinal,
        col: 24,
        hidden,
      },
      {
        label: t("prestationInputs.interventionPhone"),
        name: "intervention.phone",
        type: "input",
        required: true,
        watch: "intervention.type",
        addonBefore: "+41",
        watchRenderCondition: true,
        watchValues: [typeIntervention.phone],
        col: 24,
        hidden,
        visible: configuration?.prestation?.askPhoneInterventionPhone,
      },
      {
        label: t("prestationInputs.visioConferenceLink"),
        name: "intervention.linkVisio",
        value: prestation?.intervention?.linkVisio || null,
        type: "input",
        required: true,
        watch: "intervention.type",
        addonBefore: <BiLinkExternal />,
        watchRenderCondition: true,
        watchValues: [typeIntervention.visio],
        col: 24,
        hidden,
      },
    ],
  };
};
